import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import dayjs from 'dayjs';
import React, { forwardRef, useState, useRef, useEffect } from 'react';
import { useUncontrolled, upperFirst, useMergedRef } from '@mantine/hooks';
import { useMantineTheme } from '@mantine/core';
import { Calendar } from '../Calendar/Calendar.js';
import { DatePickerBase } from '../DatePickerBase/DatePickerBase.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var DatePicker = forwardRef(function (_a, ref) {
  var _b = _a,
    value = _b.value,
    onChange = _b.onChange,
    defaultValue = _b.defaultValue,
    classNames = _b.classNames,
    styles = _b.styles,
    _b$shadow = _b.shadow,
    shadow = _b$shadow === void 0 ? "sm" : _b$shadow,
    locale = _b.locale,
    inputFormat = _b.inputFormat,
    _b$transitionDuration = _b.transitionDuration,
    transitionDuration = _b$transitionDuration === void 0 ? 200 : _b$transitionDuration,
    transitionTimingFunction = _b.transitionTimingFunction,
    nextMonthLabel = _b.nextMonthLabel,
    previousMonthLabel = _b.previousMonthLabel,
    _b$closeCalendarOnCha = _b.closeCalendarOnChange,
    closeCalendarOnChange = _b$closeCalendarOnCha === void 0 ? true : _b$closeCalendarOnCha,
    _b$labelFormat = _b.labelFormat,
    labelFormat = _b$labelFormat === void 0 ? "MMMM YYYY" : _b$labelFormat,
    _b$withSelect = _b.withSelect,
    withSelect = _b$withSelect === void 0 ? false : _b$withSelect,
    yearsRange = _b.yearsRange,
    dayClassName = _b.dayClassName,
    dayStyle = _b.dayStyle,
    disableOutsideEvents = _b.disableOutsideEvents,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    excludeDate = _b.excludeDate,
    initialMonth = _b.initialMonth,
    _b$initiallyOpened = _b.initiallyOpened,
    initiallyOpened = _b$initiallyOpened === void 0 ? false : _b$initiallyOpened,
    _b$name = _b.name,
    name = _b$name === void 0 ? "date" : _b$name,
    _b$size = _b.size,
    size = _b$size === void 0 ? "sm" : _b$size,
    _b$dropdownType = _b.dropdownType,
    dropdownType = _b$dropdownType === void 0 ? "popover" : _b$dropdownType,
    _b$clearable = _b.clearable,
    clearable = _b$clearable === void 0 ? true : _b$clearable,
    _b$disabled = _b.disabled,
    disabled = _b$disabled === void 0 ? false : _b$disabled,
    clearButtonLabel = _b.clearButtonLabel,
    _b$fixOnBlur = _b.fixOnBlur,
    fixOnBlur = _b$fixOnBlur === void 0 ? true : _b$fixOnBlur,
    allowFreeInput = _b.allowFreeInput,
    _b$withinPortal = _b.withinPortal,
    withinPortal = _b$withinPortal === void 0 ? true : _b$withinPortal,
    dateParser = _b.dateParser,
    _b$firstDayOfWeek = _b.firstDayOfWeek,
    firstDayOfWeek = _b$firstDayOfWeek === void 0 ? "monday" : _b$firstDayOfWeek,
    onFocus = _b.onFocus,
    onBlur = _b.onBlur,
    amountOfMonths = _b.amountOfMonths,
    others = __objRest(_b, ["value", "onChange", "defaultValue", "classNames", "styles", "shadow", "locale", "inputFormat", "transitionDuration", "transitionTimingFunction", "nextMonthLabel", "previousMonthLabel", "closeCalendarOnChange", "labelFormat", "withSelect", "yearsRange", "dayClassName", "dayStyle", "disableOutsideEvents", "minDate", "maxDate", "excludeDate", "initialMonth", "initiallyOpened", "name", "size", "dropdownType", "clearable", "disabled", "clearButtonLabel", "fixOnBlur", "allowFreeInput", "withinPortal", "dateParser", "firstDayOfWeek", "onFocus", "onBlur", "amountOfMonths"]);
  var theme = useMantineTheme();
  var finalLocale = locale || theme.datesLocale;
  var dateFormat = inputFormat || theme.dateFormat;
  var _useState = useState(initiallyOpened),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownOpened = _useState2[0],
    setDropdownOpened = _useState2[1];
  var calendarSize = size === "lg" || size === "xl" ? "md" : "sm";
  var inputRef = useRef();
  var _useState3 = useState(defaultValue != null ? defaultValue : null),
    _useState4 = _slicedToArray(_useState3, 2),
    lastValidValue = _useState4[0],
    setLastValidValue = _useState4[1];
  var _useUncontrolled = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: null,
      onChange: onChange,
      rule: function rule(val) {
        return val === null || val instanceof Date;
      }
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _value = _useUncontrolled2[0],
    setValue = _useUncontrolled2[1];
  var _useState5 = useState(_value || initialMonth || new Date()),
    _useState6 = _slicedToArray(_useState5, 2),
    calendarMonth = _useState6[0],
    setCalendarMonth = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    focused = _useState8[0],
    setFocused = _useState8[1];
  var _useState9 = useState(_value instanceof Date ? upperFirst(dayjs(_value).locale(finalLocale).format(dateFormat)) : ""),
    _useState10 = _slicedToArray(_useState9, 2),
    inputState = _useState10[0],
    setInputState = _useState10[1];
  useEffect(function () {
    if (value === null && !focused) {
      setInputState("");
    }
    if (value instanceof Date && !focused) {
      setInputState(dayjs(value).locale(finalLocale).format(dateFormat));
    }
  }, [value, focused]);
  var handleValueChange = function handleValueChange(date) {
    setValue(date);
    setInputState(upperFirst(dayjs(date).locale(finalLocale).format(dateFormat)));
    closeCalendarOnChange && setDropdownOpened(false);
    window.setTimeout(function () {
      var _a2;
      return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    }, 0);
  };
  var handleClear = function handleClear() {
    var _a2;
    setValue(null);
    setLastValidValue(null);
    setInputState("");
    setDropdownOpened(true);
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  var parseDate = function parseDate(date) {
    return dateParser ? dateParser(date) : dayjs(date, dateFormat, finalLocale).toDate();
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    setFocused(false);
    var date = typeof _value === "string" ? parseDate(_value) : _value;
    if (dayjs(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(upperFirst(dayjs(date).locale(finalLocale).format(dateFormat)));
    } else if (fixOnBlur) {
      setValue(lastValidValue);
    }
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setFocused(true);
  };
  var handleChange = function handleChange(event) {
    setDropdownOpened(true);
    var date = parseDate(event.target.value);
    if (dayjs(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(event.target.value);
      setCalendarMonth(date);
    } else {
      setInputState(event.target.value);
    }
  };
  return /* @__PURE__ */React.createElement(DatePickerBase, __spreadValues({
    allowFreeInput: allowFreeInput,
    dropdownOpened: dropdownOpened,
    setDropdownOpened: setDropdownOpened,
    shadow: shadow,
    transitionDuration: transitionDuration,
    ref: useMergedRef(ref, inputRef),
    size: size,
    styles: styles,
    classNames: classNames,
    onChange: handleChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    name: name,
    inputLabel: inputState,
    __staticSelector: "DatePicker",
    dropdownType: dropdownType,
    clearable: clearable && !!_value && !disabled,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    disabled: disabled,
    withinPortal: withinPortal
  }, others), /* @__PURE__ */React.createElement(Calendar, {
    classNames: classNames,
    styles: styles,
    locale: finalLocale,
    nextMonthLabel: nextMonthLabel,
    previousMonthLabel: previousMonthLabel,
    month: allowFreeInput ? calendarMonth : void 0,
    initialMonth: initialMonth || (_value instanceof Date ? _value : new Date()),
    onMonthChange: setCalendarMonth,
    value: _value instanceof Date ? _value : dayjs(_value).toDate(),
    onChange: handleValueChange,
    labelFormat: labelFormat,
    withSelect: withSelect && !allowFreeInput,
    yearsRange: yearsRange,
    dayClassName: dayClassName,
    dayStyle: dayStyle,
    disableOutsideEvents: disableOutsideEvents,
    minDate: minDate,
    maxDate: maxDate,
    excludeDate: excludeDate,
    __staticSelector: "DatePicker",
    fullWidth: dropdownType === "modal",
    size: dropdownType === "modal" ? "lg" : calendarSize,
    firstDayOfWeek: firstDayOfWeek,
    preventFocus: allowFreeInput,
    amountOfMonths: amountOfMonths
  }));
});
DatePicker.displayName = "@mantine/dates/DatePicker";
export { DatePicker };